import React from 'react'
import './Fund.css'
import  { useEffect,useState } from 'react'
import {useParams,useHistory} from 'react-router-dom'
import { Link } from 'react-router-dom'

import doctor from '../../assets/doctor.jpg'


import { projectFirestore } from '../../firebase/Config'


export default function Fund() {
  const {id} = useParams()

  const history = useHistory()

  const [fund,setFund] = useState(null)
  const [isPending,setIsPending] = useState(false)
  const [error,setError] = useState(false)

  useEffect(()=>{
    setIsPending(true)

    const unsub = projectFirestore.collection('funds').doc(id).onSnapshot((doc)=>{
      if (doc.exists){        
        setIsPending(false)
        setFund(doc.data())
      } else {
        setIsPending(false)
        setError('could not find that fund')
      }
    })

    return()=> unsub()
    
  },[id])


  useEffect(()=>{
    if(error){
 
      const timer=setTimeout(()=>{
        history.push('/')
      },2000)
      return () => clearTimeout(timer);
    }
 
  },[error,history])
  return (
    <div>
      
    <div className='funds'>
      <br/>
      {isPending && <div>Loading...</div>}
      {error && <div className='error'>{error}</div>}
      {fund && <>


<ul>

  <li className="booking-card" ><img src={doctor}/>
    <div className="book-container">
      <div className="content">
        <button className="btn">{fund.title}</button>
      </div>
    </div>
    <div className="informations-container">
      <h2 className="title"> </h2>
      <p className="sub-title">{fund.about}</p>
      <p className="price"><svg className="icon"  viewBox="0 0 24 24">
          <path fill="currentColor" d="M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z" />
        </svg>{fund.amount} to acheive by {fund.endDate} .</p>
      <div className="more-information">
        <div className="info-and-date-container">
          <div className="box info">
            <svg className="icon"  viewBox="0 0 24 24">
              <path fill="currentColor" d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
            </svg>
            <p><Link to='/razorpay' className="card-hover__link">Donate</Link></p>
          </div>
          <div className="box date">
            <svg className="icon"  viewBox="0 0 24 24">
              <path fill="currentColor" d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" />
            </svg>
            <p>End Date : {fund.endDate}</p>
          </div>
        </div>
        <p className="disclaimer"><h5>About the Fund Raiser</h5>
           <p>NAME : {fund.name}</p>
           <p>Gender : {fund.gender}</p>
           Contacts :            
               Email : {fund.email}<br/>
              Phone No. : {fund.phoneNo}<br/>
           
            <p>Address : {fund.address}</p>
            </p>

            <p className="disclaimer"><h5>Verification Details</h5>
                     
            <p>Link of Aadhar Card : <a href="#">{fund.link}</a></p>
           <p>Hospital Name : {fund.hospitalName}</p>
           <p>Medical Certificate : <a href="#">{fund.medicalcertificate}</a></p>
           <p>Video from the User : <a href="#">{fund.video}</a></p>
            </p>
      </div>
    </div>
  </li>
</ul>

</>
//,hospitalName,endDate,,medicalcertificate,,video,
// <div classname="container-fluid">
 
 
  
//     <figure>
//       <div classname="media" ><img /></div>
//       <figcaption>
//       <svg viewBox="0 0 200 200" version="1.1" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
//           <defs>
//             <mask id="mask" x="0" y="0" width="100%" height="100%">
//               <rect id="alpha" x="0" y="0" width="100%" height="100%"></rect>
//               <text classname="title" dx="50%" dy="2.5em">{fund.title}</text>
//               <text classname="title" dx="50%" dy="3.5em">{fund.amount}  to achieve.</text>
//               <text classname="title" dx="50%" dy="4.5em">MOMENT</text>
//             </mask>
//           </defs>
//           <rect id="base" x="0" y="0" width="100%" height="100%"></rect>
      
//         <div classname="body">
//         <h5>About - </h5><p></p>
//           
//         </div>
//         </svg>
//       </figcaption> 
           
//     </figure>
//   </div>

       
      }
  </div>

    </div>
    
  )
}
    
    